import PageMain from '../../components/Navigation/PageMain/PageMain';
import { useGroupsList } from '../../sic-lib/api/hooks/useGroupsList';
import Layout from './Layout/Layout';

export default function CommunicatorPage() {
    const { isLoading, isError } = useGroupsList();

    return (
        <PageMain pageTitle="Communicator" showError={isError} showLoading={isLoading}>
            <Layout />
        </PageMain>
    );
}
